import TextField from '@mui/material/TextField';
import type { KeyboardEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

type PromptInputFieldProps = {
  value: string;
  onChange: (value: string) => void;
  onKeyDown: KeyboardEventHandler<HTMLInputElement>;
  disabled: boolean;
};

export const PromptInputField = ({ value, onChange, onKeyDown, disabled }: PromptInputFieldProps) => {
  const { t } = useTranslation();

  return (
    <TextField
      slotProps={{ htmlInput: { 'data-test': 'deal-prompt-input' } }}
      value={value}
      onChange={e => onChange(e.target.value)}
      onKeyDown={onKeyDown}
      disabled={disabled}
      multiline
      minRows={1}
      maxRows={6}
      placeholder={t('Enter your prompt')}
      variant="outlined"
      fullWidth
      sx={{
        '& .MuiInputBase-root': {
          boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.05), 0px 8px 16px -4px rgba(0,0,0,0.08)',
          pb: 12,
          pr: 4,
          borderRadius: '2px',
          borderColor: 'transparent',
          pt: 1,
          '&:hover': { backgroundColor: 'transparent' },
          '&:focus, &:active, &:focus-within': {
            borderColor: 'primary.main',
          },
          '&.Mui-disabled, textarea': {
            backgroundColor: 'transparent',
            color: disabled ? 'text.disabled' : 'text.primary',
          },
        },
      }}
    />
  );
};
